import { FC, useEffect } from 'react';
import { usePartitionChartExport } from '@utils/hook/export/UsePartitionChartExport';
import { FactRevenue } from '@utils/pageConfig/Types';
import { GrowthTypes, KpiDropdownOption } from '../performance-segment-chart/Types';
import * as styles from './ProductsSegmentMultipleChart.module.scss';
import { useExportContext } from '@hooks/export/context/ExportContext';
import { useProductsSegmentMultipleChartScales } from './hooks/UseProductsSegmentMultipleChartScales';
import { EXPORT_CHART_SIZE } from '@hooks/export/Model';
import { LeaderboardKpi } from '@models/Products';
import { ProductsLeaderboardBarChart } from '@data-visualization/products-leaderboard-bar-chart/ProductsLeaderboardBarChart';

export interface ProductsSegmentMultipleChartProps {
  topSellingProductsContent: LeaderboardKpi[];
  selectedGrowthType: GrowthTypes;
  factRevenue: FactRevenue;
  selectedKpi: KpiDropdownOption;
}

const ProductsSegmentMultipleChart: FC<ProductsSegmentMultipleChartProps> = ({
  topSellingProductsContent,
  selectedGrowthType,
  factRevenue,
  selectedKpi,
}) => {
  const { setChartRefsIsInitialisedStatus, setMultipleExportCallbacks } = useExportContext();
  const { partitionedRowsData, exportCallbacks } = usePartitionChartExport(topSellingProductsContent);
  const numberOfCharts = partitionedRowsData.length;
  const chartScales = useProductsSegmentMultipleChartScales(topSellingProductsContent, selectedGrowthType, selectedKpi);

  useEffect(() => {
    setChartRefsIsInitialisedStatus(Array(numberOfCharts).fill(false));
    setMultipleExportCallbacks(exportCallbacks);
  }, [numberOfCharts, exportCallbacks]);

  return (
    <div className={styles.hidden}>
      {partitionedRowsData.map((rowData, index) => (
        <ProductsLeaderboardBarChart
          key={`${rowData.length}${index}`} // creates a unique key for each element
          topSellingProductsContent={rowData}
          selectedGrowthType={selectedGrowthType}
          selectedKpi={selectedKpi}
          factRevenue={factRevenue}
          onExportReady={exportCallbacks[index].onExportReady}
          chartScales={chartScales}
          dimensions={EXPORT_CHART_SIZE}
          index={index}
        />
      ))}
    </div>
  );
};

export default ProductsSegmentMultipleChart;
